import { styled } from "@mui/material/styles";
import { Dialog, Radio } from "@mui/material";
import { colors } from "../../../utils";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    ".MuiBackdrop-root": {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    ".MuiPaper-root": {
        border: "1px solid #E1E1E1",
        borderRadius: 8,
        width: "40vw",
    },
}));

export const StyledRadio = styled(Radio)(() => ({
    color: colors.PrimaryPurple500,
    bottom: 12,
    "&.Mui-checked": {
        color: colors.PrimaryPurple500,
    },
    "&:hover": {
        backgroundColor: "transparent !important",
    },
}));


export const Divider = styled("div")({
    width: "100%",
    height: "1px",
    backgroundColor: colors.divider,
});

export const ToolTipStyled = styled("div")({
    marginLeft: 10,
    marginTop: 8,
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "1px solid black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "black",
    fontSize: 14,
    fontWeight: "bold",
    cursor: "pointer",
});